import { createFileRoute, redirect } from '@tanstack/react-router'
import { signOutFn } from '@/server/functions/auth'

export const Route = createFileRoute('/_auth/sign-out')({
  beforeLoad: async () => {
    await signOutFn()
    throw redirect({ to: '/' })
  },
  component: () => null,
})
